module.exports = __webpack_public_path__ + "img/LeBron-15.43dffa7a.png";